import { defineMessages } from 'react-intl';

const upgradeTravelPlanMessages = defineMessages({
  featureName: {
    id: 'unlock.travelPlan',
    defaultMessage: 'Travel Plan',
  },
  featureHeading: {
    id: 'unlock.travelPlan.heading',
    defaultMessage: 'Unlock Travel Plan',
  },
  featureSummary: {
    id: 'unlock.travelPlan.summary',
    defaultMessage: 'Plan and organize your travel more efficiently',
  },
  featureUnlockDetails: {
    id: 'unlock.travelPlan.details',
    // eslint-disable-next-line max-len
    defaultMessage: 'The Travel Plan provides a quick view of your scheduled appointments by location. It also keeps track of the high schools you would like to visit and allows you to easily identify the schools you still need to schedule.',
  },
});

export default upgradeTravelPlanMessages;
